// extracted by mini-css-extract-plugin
module.exports = {"h7":"global__h7___3_pET"};